import axios from 'axios';
import { apiClient } from './agentService';

/**
 * Settings (ayarlar) API servisi
 * Backend'den KVKK metni gibi dinamik içerikleri çeker.
 *
 * Admin isteklerinde agentService'teki paylaşılan apiClient kullanılır
 * (auth header + 401 sonrası otomatik token yenileme).
 *
 * Public isteklerde (/settings/public/*) ise auth GEREKMEZ ve bilinçli
 * olarak ayrı, kimlik doğrulamasız bir client kullanılır: widget'ı gören
 * ziyaretçinin tarayıcısında eski bir admin token'ı kalmışsa, authenticated
 * client 401 alıp oturumu kapatır ve widget'ı /login sayfasına yönlendirirdi.
 */
const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
export const settingsService = {
  /**
   * Tüm ayarları getirir
   */
  getAllSettings: async () => {
    const response = await apiClient.get('/settings');
    return response.data;
  },

  /**
   * Belirli bir ayarı key'e göre getirir
   * @param {string} key - Ayar anahtarı (örn: "KVKK_TEXT")
   */
  getSettingByKey: async (key) => {
    const response = await apiClient.get(`/settings/${key}`);
    return response.data;
  },

  /**
   * Sadece ayar değerini (value) döndürür (public endpoint — auth gerekmez)
   * @param {string} key - Ayar anahtarı
   * @returns {Promise<string>} Ayar değeri (metin)
   */
  getSettingValue: async (key) => {
    const response = await publicClient.get(`/settings/public/${key}`);
    return response.data;
  },

  /**
   * Yeni ayar oluşturur veya günceller
   * @param {Object} settingData - { settingKey, settingValue, description }
   */
  createOrUpdateSetting: async (settingData) => {
    const response = await apiClient.post('/settings', settingData);
    return response.data;
  },

  /**
   * Ayarı siler
   * @param {string} key - Ayar anahtarı
   */
  deleteSetting: async (key) => {
    const response = await apiClient.delete(`/settings/${key}`);
    return response.data;
  },
};

export default settingsService;
